<div class="leading-snug text-gray-500">
  <span>Oświadczam, że zapoznałam/łem się z </span>
  <a
    [href]="link"
    class="font-bold underline"
    target="_blank">
    <span>regulaminem serwisu purebeauty.pl</span>
  </a>
  <span>, zrozumiałam/łem go i zobowiązuję się przestrzegać.</span>
</div>
